// @core/api/endpoints/form/create_form_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFormTemplateRequest,
  FormTemplateResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Create form template
 * Creates a new reusable form template from a form schema.
 */
export async function CreateFormTemplate(
  data: CreateFormTemplateRequest,
  options?: RequestOptions
): Promise<FormTemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/forms/templates`;
  const requestOptions = options;
  return client.post<FormTemplateResponse>(requestPath, data, requestOptions);
}
